import React from 'react';

const Centered = props => (
  <div css={props.bg && { ...styles.bg, backgroundImage: `url(${props.bg})` }}>
    <div
      css={[styles.wrapper, props.bg && styles.bgOverlay]}
      className={props.className}
    >
      <div css={styles.content} className={props.contentClassName}>
        {props.children}
      </div>
    </div>
  </div>
);

export default Centered;

const styles = {
  wrapper: {
    '::before': {
      content: '""',
      display: 'inline-block',
      height: '100vh',
      verticalAlign: 'middle',
    },
  },
  bg: {
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  bgOverlay: {
    backgroundColor: 'rgba(255, 255, 255, 0.66)',
  },
  content: {
    display: 'inline-block',
    verticalAlign: 'middle',
  },
};



// WEBPACK FOOTER //
// ./src/components/Centered.js